<template>
  <div class="box">
    <div v-if="success=='true'">
      <div class="content">
        <div class="top-content">
          <img src="../assets/img/correct.png" alt="" class="correct">
          <div class="hint">订单提交成功</div>
          <div class="count">
            请您在提交订单后：<span class="countDown" v-if="requestBool">{{ countNumber }}</span>内完成支付，超时后将自动取消订单
          </div>
        </div>
      </div>
      <div class="middle-content clear">
        <div class="info">
          <p>商品信息：<span>{{ name }}</span></p>
          <p v-if="addressInfo" style="margin-top: 8px">收获姓名：啊实打实大大所大所多撒大所撒大</p>
        </div>
        <div class="money">应付金额：<span>￥{{ price }}</span></div>
        <div class="pay-type">
          <div class="title">支付平台：</div>
          <p :class="['alipay',type=='alipay'?'active':'']" @click="chooseType(1)"><img
              src="https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/dc_pay/alipaylogo.png" alt="">
          </p>
          <p :class="['wx',type=='wx'?'active':'']" @click="chooseType(2)"><img
              src="https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/dc_pay/wxlogo.png" alt=""></p>
        </div>
        <div class="btn">
          <p class="pay" @click="goToPay">去支付</p>
        </div>
      </div>
    </div>
    <div class="error-content" v-if="success=='false'">
      <img src="../assets/img/warning.png" alt="">
      <p class="hint">
        <span>抱歉，参数错误不能完成支付！</span>
      </p>
      <div class="btn clear">
        <p class="buy" @click="goBack">返回上一页</p>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'pay',
  components: {},
  data() {
    return {
      countNumber: 0,
      type: 'alipay',
      orderId: '',
      site: '',
      name: '',
      price: '',
      addressInfo: '',
      requestBool: false,
      timeInterval: '',
      businessType: '',
      notifyUrl: '',
      payWay: '',
      indexUrl: '',  // 支付失败跳转首页
      success: 'true'
    }
  },
  methods: {
    chooseType: function (val) {
      if (val === 1) {
        this.type = 'alipay';
      } else {
        this.type = 'wx';
      }
    },
    goBack() {
      window.history.back();
    },
    goToPay: function () {
      if (this.type == 'wx') {
        this.payWay = '微信支付';
      } else {
        this.payWay = '支付宝支付';
      }
      this.request('/common/pay/preCreateOrder.json', {
        method: 'post',
        data: {
          orderId: this.orderId,
          payWay: this.payWay,
          site: this.site,
          tradeType: 'NATIVE'
        }
      }).then((res) => {
        if (res.flag) {
          this.$router.push({path: '/pay.html', query: {type: this.type, orderId: this.orderId, site: this.site}})
        }

      })

    },
    countdown(val) {
      let lastTime = val;
      this.timeInterval = window.setInterval(() => {
        lastTime = lastTime - 1000;
        if (this.common.lastTime(lastTime)) {
          this.countNumber = this.common.lastTime(lastTime);
        } else {
          clearInterval(this.timeInterval);
          this.$router.push({path: '/payResult.html', query: {success: 'time', indexUrl: this.indexUrl}});
        }
        this.requestBool = true;
      }, 1000)

    }
  },
  mounted: function () {
    if (this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
    }
    if (this.$route.query.site) {
      this.site = this.$route.query.site;
    }
    this.request('/common/pay/getPayInfo.json', {
      data: {
        orderId: this.orderId,
        site: this.site,
      }
    }).then((res) => {
      if (res.data.payInfo) {
        let info = JSON.parse(res.data.payInfo.orderInfo);
        this.name = info.subject;
        this.price = info.orderPrice;
        this.businessType = info.businessType;
        this.notifyUrl = res.data.payInfo.notifyUrl;
        this.site = res.data.payInfo.site;
        this.indexUrl = res.data.payInfo.indexUrl;
        if (res.data.payInfo.leftMillisSecondsTime > 0) {
          this.countdown(res.data.payInfo.leftMillisSecondsTime);
        } else {
          this.$router.push({path: '/payResult.html', query: {success: 'time', indexUrl: this.indexUrl}});
        }
      } else {
        this.success = 'false';
      }

    })
  },
  destroyed: function () {
    clearInterval(this.timeInterval);
  }

}
</script>
<style scoped lang="scss">
.box {
  width: 1170px;
  margin: 0 auto;
  padding-top: 36px;

  .pay-title {
    font-size: 18px;
    font-weight: 600;
    color: rgba(48, 50, 51, 1);
    padding: 40px 40px 16px 40px;
    border-bottom: 1px solid rgba(237, 240, 242, 1);
    text-align: left;
    background: #fff;
  }
  .hint {
    font-size: 20px;
    font-weight: 500;
    color: #29323D;
    line-height: 28px;
    text-align: center;
    margin-top: 12px;
  }

  .content {
    padding: 40px;
    text-align: left;
    background: #fff;

    .top-content {
      .correct {
        width: 40px;
        height: 40px;
        display: block;
        margin: 0 auto;
      }

      .tips {
        margin-right: 24px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(48, 50, 51, 1);
        line-height: 26px;

      }

      .order {
        font-size: 14px;
        font-weight: 400;
        color: rgba(144, 149, 153, 1);
        line-height: 24px;
      }

      .count {
        font-weight: 400;
        color: #5C6979;
        line-height: 22px;
        text-align: center;
        font-size: 14px;
        margin-top: 8px;
        .countDown {
          color: #FF3636;
          margin: 0 3px;
        }
      }
    }
  }

  .error-content {
    padding: 20px 0 20px 32px;
    text-align: left;
    background: #fff;
    img {
      display: block;
      width: 40px;
      margin: 0 auto;
    }

    .error-tips {
      font-size: 18px;
      font-weight: 500;
      color: rgba(48, 50, 51, 1);
      line-height: 26px;

      img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 8px;
      }
    }

    .btn {
      margin-top: 100px;
      .buy {
        width: 240px;
        height: 32px;
        background: #1E7CFF;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
        margin: 0 auto;
      }

    }
  }
}

.middle-content {
  margin: 20px auto;
  background: #fff;
  width: 1090px;
  text-align: left;
  padding: 40px;

  .info {
    font-size: 14px;
    font-weight: 400;
    color: #5C6979;
    line-height: 22px;
    span {
      font-weight: 500;
      color: #29323D;
      margin-left: 8px;
    }
  }

  .money {
    font-size: 14px;
    font-weight: 400;
    color: #5C6979;
    line-height: 22px;
    margin-top: 32px;

    span {
      font-size: 24px;
      font-weight: 400;
      color: #FF3F00;
      line-height: 32px;
      margin-left: 8px;
    }
  }

  .pay-type {
    padding-top: 20px;
    display: flex;
    align-items: center;
    margin-top: 32px;

    .title {
      font-size: 14px;
      font-weight: 400;
      color: #5C6979;
      line-height: 22px;
      margin-right: 8px;
    }

    p {
      box-sizing: border-box;
      width: 180px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #E8EAEC;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 24px;
      position: relative;
      overflow: hidden;
      &.alipay {
        img {
          display: block;
          width: 71px;
        }
      }
      &.wx {
        img{
          display: block;
          width: 121px;
        }
      }
    }
    p.active {
      border: 1px solid #1E7CFF;
      background-color: #F2F7FA;
      &::after {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        right: -1px;
        bottom: -1px;
        background: url("~@/assets/img/gou.svg");
        background-size: cover;
      }
    }
  }

  .btn {
    margin-top: 100px;
    .pay {
      width: 240px;
      height: 32px;
      background: #1E7CFF;
      border-radius: 2px;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
      margin: 0 auto;
    }
  }
}
</style>
